import { PageRenderer } from "@/components/sections/PageRenderer";
import { SectionTitle } from "@/components/common/SectionTitle";
import { OfferCard } from "@/components/cards/OfferCard";
import { RedBand } from "@/components/common/RedBand";
import { Loader, EmptyState } from "@/components/common/Loader";
import { usePublicContent } from "@/lib/useContent";
import { useSite } from "@/context/SiteContext";

export default function Offers() { return <PageRenderer pageKey="offers" />; }

export const OffersBody = () => {
  const { data, loading } = usePublicContent("offers");
  const { settings } = useSite();

  return (
    <div data-testid="offers-page">
      {/* hero via PageRenderer */}

      <section id="offers-active" className="scroll-mt-24 bg-background py-16 sm:py-20">
        <div className="mx-auto w-full max-w-7xl px-4 sm:px-6">
          <SectionTitle eyebrow="Save Now" title="Active Promotions" subtitle="Use the promo code at checkout on Exercise.com. Offers update regularly — check back often." />
          <div className="mt-10">
            {loading ? (
              <Loader />
            ) : data.length === 0 ? (
              <EmptyState title="No active offers right now" description="Check back soon for new promotions." />
            ) : (
              <div className="grid gap-6 sm:grid-cols-2 lg:grid-cols-3">
                {data.map((o) => <OfferCard key={o.id} item={o} />)}
              </div>
            )}
          </div>
        </div>
      </section>

      <div id="offers-cta" className="scroll-mt-24">
      <RedBand
        eyebrow="Not Sure Where To Start?"
        title="Book A Free Intro Workout"
        text="Meet a coach, get assessed, and find the offer that fits your goals."
        primary={{ label: "Book Intro", href: settings.booking_intro_url || settings.exercise_booking_url }}
        secondary={{ label: "View Packages", to: "/packages" }}
        testid="offers-cta"
      />
      </div>
    </div>
  );
}
